<script setup>
import {onMounted, ref, reactive} from "vue";
import router from "@/router/index.js";
import {listPropertyGroup, removePropertyGroup} from "@/api/propertyGroup/propertyGroup.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  propertyGroupName: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listPropertyGroup(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    // 数据显示处理
    tableData.value.forEach(item => {
      item.propertyNameList = item.propertyNameList.join("， ")
    })
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.propertyGroupName = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '属性项', key: 'groupName', nowrap: true },
  { title: 'English', key: 'groupNameEn', nowrap: true },
  { title: '属性值', key: 'propertyNameList', nowrap: true },
  { title: '关联商品', key: 'goodsNumber', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 编辑信息
const handleEditItem = (info) => {
  router.push({path: "/addItemProp", query: {itemPropId: info.propertyGroupId}})
}
// 删除
const handleRemove = async (item) => {
  if (Number(item.goodsNumber) > 0) {
    ElMessage.error("无法删除该属性项，该属性项存在关联的商品。")
    return
  }
  await removePropertyGroup(item.propertyGroupId)
  ElMessage.success("删除成功")
  await handleSearch()
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/addItemProp")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('all', 'propertyGroup:add')">增加商品属性</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="start">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.propertyGroupName"
                        placeholder="请输入商品属性项"
                        label="属性项"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="5">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'propertyGroup:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'propertyGroup:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="handleEditItem(item)" v-show="$handleHasBtnPermission('all', 'propertyGroup:edit')"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="handleRemove(item)" :title="`确定删除属性项 “${item.groupName}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-show="$handleHasBtnPermission('all', 'propertyGroup:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>

            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>